import React from 'react';
import logo from '@assets/logo.svg';

const Logo = () => {
  return <img src={logo} alt="svisit logo" className="h-8 w-auto mx-auto" />;
};

export default Logo;
